export default {
    info: 'PERSONAL INFO',
    first_name: 'First name',
    last_name: 'Last name',
    full_name: 'Full name',
    country: 'Country',
    email: 'Email',
    username: 'Username',
    phone: 'Phone number',
    address: 'Address',
    postal_code: 'Postal code',
    account: 'Account Info',
    change_password: 'Change password',
    change_pass_current: 'Old password',
    change_pass_new: 'New password',
    change_pass_confirm: 'Confirm password',
    edit_save: 'Save',
    edit_cancel: 'Cancel',
    my_profile: 'Profile',
    city: 'City',
    province: 'State/Province',
    zip_code: 'ZIP/Postal Code',
    email_verification: 'Email verification',
    phone_verification: 'Phone number verification',
    company_name_KH: {
        en: 'Company name (EN)',
        km: 'Company name (KH)',
    },
    company_name_AE: {
        en: 'Company name',
    },
    company_name_TH: {
        en: 'Company name',
    },
    address_en: {
        KH: 'Address (EN)',
        AE: 'Address',
        TH: 'Address',
    },
    address_km: {
        KH: 'Address (KH)',
    },
    address_KH: {
        en: 'Address (EN)',
        km: 'Address (KH)',
    },
    address_AE: {
        en: 'Address',
    },
    address_TH: {
        en: 'Address',
    },
    vat_tin: {
        KH: 'VAT TIN',
        AE: 'TRN',
        TH: 'VAT TIN',
    },
    representative_en: 'Representative name',
    signature: 'Signature',
    signature_hint: 'We support PNG, JPG, JPEG, maximum {value}/file',
    company_info: 'Company info',
    change_email: 'Change email',
    current_email: 'Current Email',
    new_email: 'New Email',
    your_password: 'Your Password',
    otp_hint: 'The OTP will be sent to your current email address',
    google_account: {
        title: 'Google Account',
        link_account: 'Link Google Account',
        unlink_account: 'Unlink',
        unlink_confirm_action:
            'Are you sure you want to unlink your Google account?',
    },
};
